import { IconProps } from './IconProps';

export const ShippingBox = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      focusable="false"
      width="21"
      height="13"
      viewBox="0 0 21 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path="url(#clip0_2765_836)">
        <path
          d="M13.252 4.73818L7.64336 2.89595C7.58196 2.87548 7.54102 2.91642 7.54102 2.97782V10.6129C7.54102 10.6538 7.56149 10.6743 7.60243 10.6947L13.211 12.537C13.252 12.5574 13.3134 12.5165 13.3134 12.4551V4.82006C13.2929 4.77912 13.2724 4.75865 13.252 4.73818Z"
          fill={props.fill ?? '#202020'}
        />
        <path
          d="M18.7584 2.17953L13.7639 0.541992C13.7434 0.541992 13.7229 0.541992 13.7229 0.541992L8.7284 2.17953C8.64652 2.2 8.64652 2.30235 8.7284 2.32282L13.7229 3.96036C13.7434 3.96036 13.7639 3.96036 13.7639 3.96036L18.7584 2.32282C18.8198 2.32282 18.8198 2.22047 18.7584 2.17953Z"
          fill={props.fill ?? '#202020'}
        />
        <path
          d="M19.8438 2.89595L14.2352 4.73818C14.1943 4.75865 14.1738 4.77912 14.1738 4.82006V12.4551C14.1738 12.5165 14.2352 12.537 14.2761 12.537L19.8847 10.6947C19.9256 10.6743 19.9461 10.6538 19.9461 10.6129V2.97782C19.9461 2.91642 19.8847 2.87548 19.8438 2.89595Z"
          fill={props.fill ?? '#202020'}
        />
        <path
          d="M5.10558 2.87598H1.07314C0.7661 2.87598 0.5 3.12162 0.5 3.44912C0.5 3.75616 0.745631 4.02226 1.07314 4.02226H5.10558C5.41262 4.02226 5.67872 3.77663 5.67872 3.44912C5.65825 3.14209 5.41262 2.87598 5.10558 2.87598Z"
          fill={props.fill ?? '#202020'}
        />
        <path
          d="M5.10558 6.04785H1.07314C0.7661 6.04785 0.5 6.29348 0.5 6.62099C0.5 6.92803 0.745631 7.19413 1.07314 7.19413H5.10558C5.41262 7.19413 5.67872 6.9485 5.67872 6.62099C5.65825 6.31395 5.41262 6.04785 5.10558 6.04785Z"
          fill={props.fill ?? '#202020'}
        />
        <path
          d="M5.10558 9.24072H1.07314C0.7661 9.24072 0.5 9.48635 0.5 9.81386C0.5 10.1414 0.745631 10.387 1.07314 10.387H5.10558C5.41262 10.387 5.67872 10.1414 5.67872 9.81386C5.67872 9.48635 5.41262 9.24072 5.10558 9.24072Z"
          fill={props.fill ?? '#202020'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2765_836">
          <rect
            width="20"
            height="12"
            fill="white"
            transform="translate(0.5 0.541992)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

